import { render, staticRenderFns } from "./AutorizedConsumers.vue?vue&type=template&id=f54c62f8"
import script from "./AutorizedConsumers.vue?vue&type=script&lang=js"
export * from "./AutorizedConsumers.vue?vue&type=script&lang=js"
import style0 from "./AutorizedConsumers.vue?vue&type=style&index=0&id=f54c62f8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f54c62f8')) {
      api.createRecord('f54c62f8', component.options)
    } else {
      api.reload('f54c62f8', component.options)
    }
    module.hot.accept("./AutorizedConsumers.vue?vue&type=template&id=f54c62f8", function () {
      api.rerender('f54c62f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AutorizedConsumers.vue"
export default component.exports